var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#verified_svg__filter0_d_4289_15281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5L4.125 5.898v14.891l.736.506c2.098 1.41 4.6 2.169 7.139 2.205 2.54-.036 5.041-.795 7.139-2.205l.736-.47V5.898L12 2.5z",
    fill: "url(#verified_svg__paint0_radial_4289_15281)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 20.414v.375l.736.506c2.098 1.41 4.6 2.169 7.139 2.205 2.54-.036 5.041-.795 7.139-2.205l.736-.47v-.375l-.736.47c-2.098 1.41-4.6 2.169-7.139 2.205-2.54-.036-5.041-.795-7.139-2.205l-.736-.506z",
    fill: "url(#verified_svg__paint1_linear_4289_15281)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#verified_svg__filter1_d_4289_15281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 15.159l5.17-5.171.796.795-5.966 5.967-3.58-3.58.795-.796 2.785 2.785z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "verified_svg__filter0_d_4289_15281",
    x: 0.125,
    y: 0.5,
    width: 23.75,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4289_15281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4289_15281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "verified_svg__filter1_d_4289_15281",
    x: 6.795,
    y: 9.488,
    width: 11.546,
    height: 8.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4289_15281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4289_15281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "verified_svg__paint0_radial_4289_15281",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-15.7499 18.37508 -13.78133 -11.81244 19.875 2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A92F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3273FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "verified_svg__paint1_linear_4289_15281",
    x1: 12,
    y1: 20.414,
    x2: 12,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC1FF"
  })))));
}
export default __webpack_public_path__ + "static/svg/verified.svg";
export { SvgVerified as ReactComponent };